import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { CustomLink } from '../../../../common/CustomLink'
import { Element } from '../../../../common/html/element'
import { TextEllipsisStaticLine } from '../../../../common/textEllipsis/TextEllipsisStaticLine'
import { formatText } from '../../../../helpers/value'
import { COMPONENTS } from '../../../../routers/constants'
import { VALUE_SCORE } from '../../constant'
import { IDS_TREND_BY_PORT } from '../constant'
import { getDataReduxTable, getDataReduxTablePer } from '../store/slice'

export const NamePort = ({ data, rowId, isDynamicReport, typeValue }) => {
  const dataRowRisk = useSelector(getDataReduxTable(rowId))
  const dataRowPer = useSelector(getDataReduxTablePer(rowId))
  const dataRow =
    typeValue === VALUE_SCORE.CREDIT_SCORE ? dataRowRisk : dataRowPer

  const dataDetails = Object.values(dataRow || {}).find(
    (item) => !!item?.portfolioId,
  )

  if (isDynamicReport) {
    return (
      <Element className="fw600">
        <Translate value={`portfolioScore.namePortById.${data}`} />
      </Element>
    )
  }

  return (
    <>
      <Element>
        <Element className="fw600">
          <TextEllipsisStaticLine
            text={`portfolioScore.namePortById.${data}`}
            lineClamp={1}
            isI18n
          />
        </Element>
        {data !== IDS_TREND_BY_PORT.FILTERED && (
          <CustomLink
            target="_blank"
            to={
              dataDetails?.portfolioId
                ? `${COMPONENTS.library.components.savedPortfolios.components.detailsPortfolio.route}?id=${dataDetails?.portfolioId}`
                : ''
            }
          >
            <Element
              className="fstItalic"
              style={{
                color: dataDetails?.portfolioName ? '#2C73E8' : '',
              }}
            >
              ({formatText(dataDetails?.portfolioName)})
            </Element>
          </CustomLink>
        )}
      </Element>
    </>
  )
}
